import { Link } from "react-router-dom";
import { ContactModal } from "../components/ContactModal";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { useContactModal } from "../context/contactModal";
import { COMPANY } from "../data/company";
export const AboutPage = () => {
  const { isOpen, closeModal } = useContactModal();
  return (
    <div className="min-h-screen bg-[#131313]">
      <Header />
      <main>
        <section className="pt-48 pb-20 bg-[#131313] text-white">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">About Actrium AI</h1>
            </div>
          </div>
        </section>
        <section className="py-20 bg-[#131313] text-white">
          <div className="container mx-auto px-4">
            <div className="mx-auto max-w-4xl">
              <div className="mb-10">
                <p className="mb-3 text-base font-bold uppercase tracking-[0.18em] text-[#B3C9FE]">Mission</p>
                <h2 className="text-3xl md:text-4xl font-bold">Our Mission</h2>
                <p className="mt-4 max-w-3xl text-base leading-relaxed text-gray-300">
                  We help robots learn the missing physical causality behind contact, grip, force, failure
                  recovery, and everyday human operation.
                </p>
              </div>
              <div className="grid gap-6 md:grid-cols-3">
                <div className="rounded-md border border-white/10 bg-white/[0.04] p-6">
                  <h3 className="text-xl font-bold text-white mb-3">Physical Data</h3>
                  <p className="text-base text-gray-300">
                    Pairing visual, inertial, tactile and FMG observations with task context and independently
                    verified labels.
                  </p>
                </div>
                <div className="rounded-md border border-white/10 bg-white/[0.04] p-6">
                  <h3 className="text-xl font-bold text-white mb-3">Data Governance</h3>
                  <p className="text-base text-gray-300">
                    Turning raw multimodal traces into clean, structured, training-ready assets.
                  </p>
                </div>
                <div className="rounded-md border border-white/10 bg-white/[0.04] p-6">
                  <h3 className="text-xl font-bold text-white mb-3">Robot Feedback</h3>
                  <p className="text-base text-gray-300">
                    Connect task evaluation and failure analysis to targeted data collection, improving
                    datasets and models over time.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="py-20 bg-[#131313] text-white">
          <div className="container mx-auto px-4">
            <div className="mx-auto max-w-4xl">
              <div className="mb-10">
                <p className="mb-3 text-base font-bold uppercase tracking-[0.18em] text-[#B3C9FE]">Team</p>
                <h2 className="text-3xl md:text-4xl font-bold">Leadership</h2>
              </div>
              <div className="grid gap-6 md:grid-cols-2">
                {COMPANY.team.map((n) => (
                  <article className="rounded-md border border-white/10 bg-white/[0.04] p-6" key={n.name}>
                    <h3 className="text-2xl font-bold text-white">{n.name}</h3>
                    <p className="mt-2 text-base font-semibold text-[#B3C9FE]">{n.role}</p>
                    <p className="mt-4 text-base text-gray-300">Responsible for {n.focus.toLowerCase()}.</p>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>
        <section className="py-20 bg-[#101010] text-white">
          <div className="container mx-auto px-4">
            <div className="mx-auto max-w-4xl">
              <div className="mb-10">
                <p className="mb-3 text-base font-bold uppercase tracking-[0.18em] text-[#B3C9FE]">Company</p>
                <h2 className="text-3xl md:text-4xl font-bold">Company & Brand</h2>
                <p className="mt-4 max-w-3xl text-base leading-relaxed text-gray-300">
                  Actrium AI is the public-facing brand operated by {COMPANY.legalName}, a Delaware
                  corporation qualified to do business in New York.
                </p>
              </div>
              <div className="rounded-md border border-white/10 bg-white/[0.04] p-6">
                <p className="text-base leading-relaxed text-gray-300">
                  Legal registration details and original filing certificates are available for customers,
                  partners, and compliance review.
                </p>
                <Link
                  to="/legal-entity"
                  className="mt-5 inline-flex rounded-md border border-white/15 px-5 py-3 text-base font-bold text-white transition-colors hover:border-[#006AFF] hover:text-[#B3C9FE]"
                >
                  View legal entity details
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="py-20 bg-[#101010] text-white">
          <div className="container mx-auto px-4">
            <div className="mx-auto max-w-4xl">
              <div className="mb-10">
                <p className="mb-3 text-base font-bold uppercase tracking-[0.18em] text-[#B3C9FE]">
                  Operations
                </p>
                <h2 className="text-3xl md:text-4xl font-bold">U.S. Operations & Data Residency</h2>
              </div>
              <div className="rounded-md border border-white/10 bg-white/[0.04] p-6">
                <p className="text-base leading-relaxed text-gray-300">
                  Actrium AI is a U.S.-based company building Physical AI data infrastructure for robotics
                  teams, labs, and enterprise deployment partners.
                </p>
                <p className="mt-4 text-base leading-relaxed text-gray-300">
                  Customer data is stored and processed in the United States by default. For sensitive human
                  demonstration, robot execution, and deployment feedback data, our workflows are designed
                  around U.S. data residency, privacy-aware processing, and controlled access.
                </p>
                <div className="mt-6 border-t border-white/10 pt-6">
                  <p className="text-base font-semibold text-white">{COMPANY.legalName}</p>
                  <address className="not-italic text-base leading-relaxed text-gray-300">
                    {COMPANY.addressLine1}
                    <br />
                    {COMPANY.addressLine2}
                  </address>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <ContactModal isOpen={isOpen} onClose={closeModal} />
    </div>
  );
};
